import { store } from "@store/store";
import queryString from "query-string";

export const NoLoginRequiredURL = [
  "/login",
  "/signup",
  "/add-password",
  "/reset-password",
  "/authorization",
  "/privacy-policy",
];

export const PAGES = {
  OVERVIEW: "/overview",
  OVERVIEW_COUNTRY: "/overview/country",
  CATEGORY_DETAIL: "/category/detail",
  OVERVIEW_TOPLIST: "/overview/toplist",
  VIDEO: "/video",
  VIDEO_DETAIL: "/video/detail",
  PRODUCT: "/product",
  PRODUCT_DETAIL: "/product/detail",
  Live: "/livestream",
  LIVE_DETAIL: "/livestream/detail",
  CREATOR: "/creator",
  CREATOR_DETAIL: "/creator/detail",
  SHOP: "/shop",
  SHOP_DETAIL: "/shop/detail",
  PRICING: "/pricing",
  AI_VIDEO_INSIGHT: "/insight",
  AI_SCRIPT_REWRITE: "/script-rewrite",
  AI_SCRIPT_REVIEW: "/script-review",
};

export const DEFAULT_PAGE = "/video";

export const combine = (path: string, params: object) => {
  return path + "?" + queryString.stringify(params);
};

interface GoPageDetailProps {
  path: string;
  params: {
    id?: string;
    dateRange?: string[];
    cateValue?: unknown;
    region?: string;
    language?: string;
    currency?: string;
    module?: string;
  };
  state?: object;
  elParams?: object;
}

export const getPageDetailUrl = ({ path, params, state = {}, elParams }: GoPageDetailProps) => {
  const globalState = store.getState();
  history.replaceState({ ...window.history.state, usr: { ...state } }, "");
  const searchParams: any = {
    id: params.id,
    language: params?.language || globalState.globalReducer.language,
    currency: params?.currency || globalState.globalReducer.currency,
    region: params.region ? params.region : globalState.globalReducer.region,
    ...elParams,
  };
  if (params.dateRange) {
    searchParams["dateRange"] = JSON.stringify(params.dateRange);
  }
  if (params.cateValue) {
    searchParams["cateValue"] = JSON.stringify(params.cateValue);
  }
  if (params?.module) {
    searchParams["module"] = JSON.stringify(params.module);
  }
  const urlParams = new URLSearchParams(searchParams).toString();

  const url = `${path}?${urlParams}`;

  return url;
};

export const goPageIndex = () => {
  window.location.href = "/";
};

/**
 * 获取安全的登录/注册后回调地址
 * 优先使用 URL 中的 redirectUrl 参数，其次使用传入的 fallback，最后兜底到 DEFAULT_PAGE
 * 如果回调地址是不需要登录的页面（如 /authorization、/login 等），则重定向到默认首页
 */
export const getSafeRedirectURL = (redirectUrl?: string): string => {
  const urlParams = new URLSearchParams(window.location.search);
  let paramsRedirectUrl = "";
  const rawRedirectUrl = urlParams.get("redirectUrl") || "";
  try {
    paramsRedirectUrl = decodeURIComponent(rawRedirectUrl);
  } catch (error) {
    paramsRedirectUrl = "";
  }
  if (["/authorization"].includes(paramsRedirectUrl)) return DEFAULT_PAGE;
  return paramsRedirectUrl || redirectUrl || DEFAULT_PAGE;
};
